export enum TypeEnum {
  Date = 1,
  Enum = 2,
  String = 3,
  Boolean = 4,
}

export type filterOption = {
  id?: number;
  name?: string;
  filterName?: string;
  options: Option[];
};

export type Option = {
  id: number;
  field?: string;
  value:
    | string
    | Date
    | number
    | boolean
    | { label: string; value: string | number | Date | boolean };
  label?: string;
  options:
    | undefined
    | {
        value: string | number | boolean;
        label: string;
      }[];
  type: TypeEnum | undefined;
  isSelected: boolean;
};
